import { render, staticRenderFns } from "./allComprasOrdenTrabajo.vue?vue&type=template&id=2ecad2f8&scoped=true"
import script from "./allComprasOrdenTrabajo.vue?vue&type=script&lang=js"
export * from "./allComprasOrdenTrabajo.vue?vue&type=script&lang=js"
import style0 from "./allComprasOrdenTrabajo.vue?vue&type=style&index=0&id=2ecad2f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ecad2f8",
  null
  
)

export default component.exports